
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TripChange } from '@clients/myTrips';
import SortOrderEnum from '@/models/SortOrderEnum';

@Component({
  name: 'TripDetailTabChanges',
  components: {

  }
})
export default class TripDetailTabChanges extends Vue {
  @Prop()
  changes: Array<TripChange>;

  private changesSortDir: SortOrderEnum = SortOrderEnum.DESC;

  get sortedChanges(): Array<TripChange> {
    return this.changes.map(change => ({
      ...change,
      descriptions: change.descriptions.map(desc => Object.keys(desc).map(key => desc[key]).join('')),
    })).sort((a, b) => {
      let modifier = 1;
      if (this.isDescendingSorted) {
        modifier = -1;
      }
      if (a.date < b.date) {
        return -1 * modifier;
      }
      if (a.date > b.date) {
        return modifier;
      }
      return 0;
    });
  }

  private sort() {
    this.changesSortDir = this.isDescendingSorted ? SortOrderEnum.ASC : SortOrderEnum.DESC;
  }

  get isDescendingSorted() {
    return this.changesSortDir === SortOrderEnum.DESC;
  }
}
